import TemplateView from "../../../TemplateView";
import messageResource from "../../../messageResource";
import UserNameFormat from "../../../util/UserNameFormat";
import SpinnerController from "../../../SpinnerController";

export default class Header extends TemplateView
{
    constructor()
    {
        super(null);
        this.lastLoginTime = null;
        this.userName = null;
        this.delDisabled = false;

        this.state = {
            hasTimeTrack: null,
            loggedIn: null,
            lastOtherProductAdmin: null,
            firstName: null,
            lastName: null,
            middleInitial: null,
            lastLoginTime: null,
            updateLoading: null,
            noRightsToDelete: false,
        }

        this.onStateChanged(() => this.update())
        this.onStatePropertyChanged('lastLoginTime', (lastLoginTime) => {
            this.$lastLoginLabel.text(messageResource.getMessage(lastLoginTime?  "user.panel.header.last_login" : "user.panel.header.never_logged_in"));
            this.$lastLoginTimestamp.text(lastLoginTime ? lastLoginTime : "");
        });

        const onNameChanged = () => {
            this.$userName.text(UserNameFormat.formatFML(this.state.firstName, this.state.lastName, this.state.middleInitial));
        }

        this.onStatePropertyChanged('firstName', onNameChanged);
        this.onStatePropertyChanged('lastName', onNameChanged);
        this.onStatePropertyChanged('middleInitial', onNameChanged);

        const toggleDeleteButtonState = () => {
            this.$deleteButton.toggle(!this.state.loggedIn && !this.state.noRightsToDelete)
            this.delDisabled = this.state.hasTimeTrack || this.state.lastOtherProductAdmin || this.state.noRightsToDelete
            this.$deleteButton.toggleClass('disabled', !!this.delDisabled)
            let tooltip = null
            if (this.state.hasTimeTrack)
                tooltip = messageResource.getMessage("user.edit.js.cannot_delete.has_task_record")
            else if (this.state.lastOtherProductAdmin)
                tooltip = messageResource.getMessage("user.edit.js.cannot_delete.last_admin_ap")

            if (tooltip)
                this.$deleteButton.attr('title', tooltip)
            else
                this.$deleteButton.removeAttr('title')
        }
        this.onStatePropertyChanged('hasTimeTrack', toggleDeleteButtonState);
        this.onStatePropertyChanged('loggedIn', toggleDeleteButtonState);
        this.onStatePropertyChanged('lastOtherProductAdmin', toggleDeleteButtonState);
        this.onStatePropertyChanged('noRightsToDelete', toggleDeleteButtonState)

        this.onStatePropertyChanged('updateLoading', (loading) => loading ? this.spinner.spinInElement(this.$spinner) : this.spinner.stop());
    }

    templateHtml()
    {
        return "<div class='header userPanel_panelHeader'>" +
               "    <div class='lastLogin'>" +
               "        <span class='loggedInLabel'/> <span class='lastLoginTimestamp'/>" +
               "    </div>" +
               "    <div class='userName nameInfo ellipsis'/>" +
               "    <div class='tabs'>" +
               "        <div class='accountSettingsTab'><span class='tabText'><%=accountSettingsTab%></span></div>" +
               "        <div class='permissionsTab'><span class='tabText'><%=permissionsTab%></span></div>" +
               "    </div>" +
               "    <div class='actions'><div class='actionButtonWrapper'>" +
               "        <div class='deleteButton actionButton'><div class='action'><%=deleteButton%></div></div>" +
               "    </div></div>" +
               "    <div class='spinner'/>" +
               "</div>"
    }

    messageKeys()
    {
        return {
            accountSettingsTab: "user.panel.header.tabs.account",
            permissionsTab: "user.panel.header.tabs.permissions",
            deleteButton: "user.panel.header.delete",
        }
    }

    afterRender()
    {
        this.$lastLoginLabel = this.find(".loggedInLabel");
        this.$lastLoginTimestamp = this.find('.lastLoginTimestamp');
        this.$userName = this.find('.userName');
        this.$accountSettingsTab = this.find('.accountSettingsTab');
        this.$permissionsTab = this.find('.permissionsTab');
        this.$deleteButton = this.find('.deleteButton');
        this.$deleteButton.click(() => {
            if (!this.delDisabled)
                this.trigger('deleteUser')
        });
        this.$spinner = this.find('.spinner');
        this.spinner = new SpinnerController();
        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/Header.js